import { useTranslation } from 'react-i18next';

const useLocaleUrl = () => {
  const { i18n } = useTranslation();

  const localeUrl = (path: string) => {
    if (path && path.indexOf('http') >= 0) return path;
    let retPath: string | null = null;
    if (path && path[0] === '/') {
      retPath = `/${(i18n && i18n.language) || 'en'}${path}`;
    } else {
      retPath = `/${(i18n && i18n.language) || 'en'}/${path}`;
    }
    return retPath.replace('/en/', '/');
  };

  return localeUrl;
};

export default useLocaleUrl;
